import React, { useEffect, useState } from "react";
import { BASE_URL } from "../../../global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import PreviewIcon from "@mui/icons-material/Preview";
import DeleteIcon from "@mui/icons-material/Delete";
import Toolbar from "@mui/material/Toolbar";
import { Link, useLocation } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import { useTheme } from "@mui/material/styles";
import {
  TextField,
  Autocomplete,
  Table,
  Grid,
  useMediaQuery,
  Modal,
} from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import SearchIcon from "@mui/icons-material/Search";
import Box from "@mui/material/Box";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import IconButton from "@mui/material/IconButton";
import axiosWithToken from "../../../utils/components/axiosTokenConfig";
import ListWrap from "../../commonComponent/listWrap";
import { paginationrowsPerPageOptions } from "../../../constants/commonConst";
import { gaugeTypeOptions } from "./editThreadRingPlug";
import ThreadRingPlugExcelUploadModal from "./threadRingPlugExcelUploadModal";

const columns = [
  { id: "id", label: "Sr. No.", minWidth: 40 },
  { id: "gaugeType", label: "Gauge Type", minWidth: 120 },
  { id: "specification", label: "Specification", minWidth: 120 },
  { id: "goMajorMax", label: "GO Major Max", align: "center", minWidth: 80 },
  { id: "goMajorMin", label: "GO Major Min", align: "center", minWidth: 80 },
  { id: "goMajorWearLimit", label: "GO Major Wear", align: "center", minWidth: 80 },
  { id: "nogoMajorMax", label: "NOGO Major Max", align: "center", minWidth: 80 },
  { id: "nogoMajorMin", label: "NOGO Major Min", align: "center", minWidth: 80 },
  { id: "nogoMajorWearLimit", label: "NOGO Major Wear", align: "center", minWidth: 80 },
  { id: "goEffectiveMax", label: "GO Effective Max", align: "center", minWidth: 80 },
  { id: "goEffectiveMin", label: "GO Effective Min", align: "center", minWidth: 80 },
  { id: "goEffectiveWearLimit", label: "GO Effective Wear", align: "center", minWidth: 80 },
  { id: "NogoEffectiveMax", label: "NOGO Effective Max", align: "center", minWidth: 80 },
  { id: "NogoEffectiveMin", label: "NOGO Effective Min", align: "center", minWidth: 80 },
  { id: "NogoEffectiveWearLimit", label: "NOGO Effective Wear", align: "center", minWidth: 80 },
];

export default function ThreadRingPlugList(props) {
  const isMobile = useMediaQuery("(max-width: 600px)");
  const urlPath = useLocation();
  const [page, setPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 10));
  const [dataList, setDataList] = useState([]);
  const [searchBy, setSearchBy] = useState(sessionStorage.getItem("searchBy") || "Specification");
  const [searchKey, setSearchKey] = useState(sessionStorage.getItem("searchKey") || "");
  const [totalRows, setTotalRows] = useState(0);
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [searched, setSearched] = useState(false);

  const handleFilterOpen = () => setFilterModalOpen(true);
  const handleFilterClose = () => setFilterModalOpen(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    sessionStorage.setItem("currentPath", urlPath.pathname);
    sessionStorage.setItem("ListPageCount", newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const val = +event.target.value;
    setRowsPerPage(val);
    setPage(0);
    sessionStorage.setItem("ListRowsPerPage", val);
    sessionStorage.setItem("ListPageCount", 0);
  };

  const getQuery = (count) => {
    let whereConditions = "";
    let pagination_settings = "";

    if (searchBy !== "" && searchKey !== "") {
      const colName = {
        Specification: "specification",
        "Gauge Type": "gaugeType",
      }[searchBy] || "specification";

      if (colName === "gaugeType") {
        const lower = searchKey.trim().toLowerCase();
        if ("thread plug gauge".includes(lower)) {
          whereConditions = "WHERE gaugeType = 1";
        } else if ("thread ring gauge".includes(lower)) {
          whereConditions = "WHERE gaugeType = 2";
        } else if (!isNaN(searchKey)) {
          whereConditions = `WHERE gaugeType = ${parseInt(searchKey)}`;
        } else {
          whereConditions = `WHERE LOWER(specification) LIKE LOWER('%${searchKey.trim()}%')`;
        }
      } else {
        whereConditions = `WHERE LOWER(${colName}) LIKE LOWER('%${searchKey.trim()}%')`;
      }
    }

    if (rowsPerPage !== -1) {
      pagination_settings = `LIMIT ${rowsPerPage} OFFSET ${rowsPerPage * Number(page)}`;
    }

    let data = {
      query: `SELECT * FROM ThreadPlugRingSizes ${whereConditions} ORDER BY id DESC ${pagination_settings}`,
    };

    if (count) {
      data.query = `SELECT COUNT(*) AS no_of_rows FROM ThreadPlugRingSizes ${whereConditions}`;
    }
    return data;
  };

  function getDList() {
    let data = getQuery();
    axiosWithToken
      .post(BASE_URL + "dynamic", data)
      .then((res) => {
        setDataList([...(res.data || [])]);
      })
      .catch((err) => {
        console.error("Error fetching Thread Ring/Plug list: ", err);
      });
  }

  function getTotalRows() {
    let data = getQuery(true);
    axiosWithToken
      .post(BASE_URL + "dynamic", data)
      .then((res) => {
        setTotalRows(res.data[0]?.no_of_rows || 0);
      })
      .catch((err) => {
        console.error("Error fetching count: ", err);
      });
  }

  const TablePaginationActions = (props) => {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  };

  const storedSearchBy = sessionStorage.getItem("searched");
  useEffect(() => {
    if (storedSearchBy === "true") {
      setSearched(true);
    }
  }, [storedSearchBy]);

  const search = () => {
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", urlPath.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setPage(0);
    setSearched(true);
    getDList();
    getTotalRows();
  };

  const clearSearch = () => {
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    sessionStorage.removeItem("currentPath");
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    setPage(0);
    setSearchBy("Specification");
    setSearchKey("");
    setSearched(false);
  };

  useEffect(() => {
    getDList();
    getTotalRows();
  }, [rowsPerPage, page]);

  useEffect(() => {
    if (searched === false) {
      getDList();
      getTotalRows();
    }
    if (searched) {
      setPage(Number(sessionStorage.getItem("ListPageCount") || 0));
    }
  }, [searched]);

  const handleDelete = (id) => {
    if (window.confirm("Really want to delete specification?")) {
      axiosWithToken
        .delete(`${BASE_URL}ThreadPlugRingSizes/${id}`)
        .then(() => {
          toast("specification was deleted!");
          getDList();
          getTotalRows();
        })
        .catch((err) => {
          console.error("Error deleting specification:", err);
          toast.error("Failed to delete specification");
        });
    }
  };

  const getGaugeTypeLabel = (typeId) => {
    const found = gaugeTypeOptions.find((opt) => opt.id === Number(typeId));
    return found ? found.label : typeId || "";
  };

  const filterSection = () => (
    <Grid
      container
      spacing={1.5}
      alignItems="center"
      style={{ padding: "5px 0px", marginBottom: "2px" }}
    >
      <Grid item xs={12} sm={4} md={2.5} lg={2} id="thread_ring_plug_searchby">
        <Autocomplete
          sx={{ m: 0, minWidth: 180 }}
          className="Listinputcss"
          size="small"
          value={searchBy}
          options={["Specification", "Gauge Type"]}
          renderInput={(params) => <TextField {...params} label="Search By" />}
          onInputChange={(event, newInputValue) => {
            if (newInputValue) {
              setSearchBy(newInputValue);
              setSearched(false);
            }
          }}
        />
      </Grid>
      <Grid item xs={12} sm={4} md={2.5} lg={2}>
        <TextField
          id="thread_ring_plug_searchbytext"
          label={"enter " + searchBy}
          size="small"
          className="Listinputcss"
          variant="outlined"
          value={searchKey}
          inputProps={{ autoComplete: "off" }}
          style={{ width: "100%" }}
          onChange={(e) => {
            setSearchKey(e.target.value);
            setSearched(false);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              searched ? clearSearch() : search();
            }
          }}
        />
      </Grid>
      <Grid item xs="auto">
        <Button
          id="thread_ring_plug_searchbtn"
          variant="contained"
          size="small"
          color={searched ? "error" : "primary"}
          onClick={() => {
            searched ? clearSearch() : search();
            handleFilterClose();
          }}
        >
          {searched ? <RestartAltIcon /> : <SearchIcon />}
        </Button>
      </Grid>
      <Grid item xs="auto">
        <ThreadRingPlugExcelUploadModal
          onSuccess={() => {
            getDList();
            getTotalRows();
          }}
        />
      </Grid>
    </Grid>
  );

  const filterModal = () => (
    <Modal open={filterModalOpen} onClose={handleFilterClose}>
      <Box
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "calc(100% - 30%)",
          backgroundColor: "white",
          boxShadow: 24,
          padding: "10px",
        }}
      >
        <Button
          variant="contained"
          size="small"
          color="error"
          style={{ float: "right" }}
          onClick={handleFilterClose}
        >
          X
        </Button>
        {filterSection()}
      </Box>
    </Modal>
  );

  return (
    <ListWrap>
      {filterModal()}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Toolbar style={{ padding: "0px" }}>
          <Button
            id="thread_ring_plug_createbtn"
            variant="contained"
            size="small"
            component={Link}
            to="/master/editThreadRingPlug/0"
          >
            <b>CREATE Thread ring/plug</b>
          </Button>
        </Toolbar>
        <Box sx={{ display: "flex", gap: "0rem" }}>
          <Button
            style={{ display: isMobile ? "block" : "none" }}
            onClick={handleFilterOpen}
          >
            <FilterAltIcon />
          </Button>
        </Box>
      </div>

      {!isMobile && filterSection()}

      <TableContainer sx={{ maxHeight: isMobile ? "80vh" : "65vh" }}>
        <Table
          stickyHeader
          aria-label="sticky table"
          size="small"
          id="thread_ring_plug_table"
          sx={{ borderCollapse: "collapse" }}
        >
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align || "left"}
                  style={{ minWidth: column.minWidth }}
                >
                  <b>{column.label}</b>
                </TableCell>
              ))}
              <TableCell align="center">
                <b>Actions</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dataList?.length > 0 ? (
              dataList.map((row, index) => (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.id || index}>
                  <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                  <TableCell>{getGaugeTypeLabel(row.gaugeType)}</TableCell>
                  <TableCell>{row.specification || ""}</TableCell>
                  <TableCell align="center">{row.goMajorMax ?? ""}</TableCell>
                  <TableCell align="center">{row.goMajorMin ?? ""}</TableCell>
                  <TableCell align="center">{row.goMajorWearLimit ?? ""}</TableCell>
                  <TableCell align="center">{row.nogoMajorMax ?? ""}</TableCell>
                  <TableCell align="center">{row.nogoMajorMin ?? ""}</TableCell>
                  <TableCell align="center">{row.nogoMajorWearLimit ?? ""}</TableCell>
                  <TableCell align="center">{row.goEffectiveMax ?? row.goMax ?? ""}</TableCell>
                  <TableCell align="center">{row.goEffectiveMin ?? row.goMin ?? ""}</TableCell>
                  <TableCell align="center">{row.goEffectiveWearLimit ?? row.goWearLimit ?? ""}</TableCell>
                  <TableCell align="center">{row.NogoEffectiveMax ?? row.nogoEffectiveMax ?? row.nogoMax ?? ""}</TableCell>
                  <TableCell align="center">{row.NogoEffectiveMin ?? row.nogoEffectiveMin ?? row.nogoMin ?? ""}</TableCell>
                  <TableCell align="center">{row.NogoEffectiveWearLimit ?? row.nogoEffectiveWearLimit ?? row.nogoWearLimit ?? ""}</TableCell>
                  <TableCell align="center">
                    <ButtonGroup size="small" aria-label="small button group">
                      <Tooltip title="Edit Specification" placement="top-start">
                        <Button
                          id="thread_ring_plug_edit"
                          component={Link}
                          to={`/master/editThreadRingPlug/${row.id}`}
                        >
                          <PreviewIcon />
                        </Button>
                      </Tooltip>
                      <Tooltip title="Delete Specification" placement="top-start">
                        <Button
                          id="thread_ring_plug_delete"
                          onClick={() => handleDelete(row.id)}
                        >
                          <DeleteIcon style={{ color: "#dc3545" }} />
                        </Button>
                      </Tooltip>
                    </ButtonGroup>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={columns.length + 1} align="center">
                  <h6><b>Data Not Found</b></h6>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={paginationrowsPerPageOptions}
        count={totalRows}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        component="div"
        colSpan={3}
        SelectProps={{
          inputProps: {
            "aria-label": "rows per page",
          },
          native: true,
        }}
        ActionsComponent={TablePaginationActions}
      />
      <ToastContainer />
    </ListWrap>
  );
}
